<template>
  <div class="ren-decoration-cp ren-decoration-cp-product-info" :style="cardStyle">
    <b v-if="hasPrice">¥{{ formatMoney(price) }}</b>
    <small v-if="showMarketPrice && marketPrice > price">¥{{ formatMoney(marketPrice) }}</small>
    <strong>{{ title }}</strong>
    <span v-if="subtitle">{{ subtitle }}</span>
    <em v-if="metaText">{{ metaText }}</em>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  booleanValue,
  formatMoney,
  numberValue,
  previewBoundString,
  previewDataRecord,
  stringValue
} from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const data = computed(() => previewDataRecord(props.componentData))
const title = computed(() =>
  previewBoundString(props.component, props.componentData, 'title', stringValue(data.value.title, '商品标题'))
)
const subtitle = computed(() =>
  previewBoundString(
    props.component,
    props.componentData,
    'subtitle',
    stringValue(data.value.subtitle ?? data.value.sellingPoint)
  )
)
const price = computed(() => numberValue(data.value.minSalePrice ?? data.value.price, 0))
const marketPrice = computed(() => numberValue(data.value.marketPrice ?? data.value.originalPrice, 0))
const hasPrice = computed(() => price.value > 0)
const showMarketPrice = computed(() => booleanValue(props.component.props?.showMarketPrice, true))
const showSales = computed(() => booleanValue(props.component.props?.showSales, true))
const showStock = computed(() => booleanValue(props.component.props?.showStock, true))
const metaText = computed(() => {
  const parts: string[] = []
  if (showSales.value && data.value.salesCount != null) parts.push(`已售 ${data.value.salesCount}`)
  if (showStock.value && data.value.totalStock != null) parts.push(`库存 ${data.value.totalStock}`)
  return parts.join(' · ')
})
const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})
</script>

<style scoped>
.ren-decoration-cp-product-info {
  display: grid;
  gap: 4px;
  padding: 12px;
}

.ren-decoration-cp-product-info b {
  color: var(--ren-theme-primary);
  font-size: 16px;
}

.ren-decoration-cp-product-info small {
  color: var(--ren-theme-muted);
  text-decoration: line-through;
}

.ren-decoration-cp-product-info span,
.ren-decoration-cp-product-info em {
  color: var(--ren-theme-muted);
  font-size: 12px;
  font-style: normal;
}
</style>
